export const getTgSpecificOtsForSegmentUrl =
  "/api/v3/target_group/:tgId/mavin/ots/road_segment/:segmentId";
// export const getTgSpecificOtsForCity =
//   "/api/v3/target_group/:tgId/mavin/ots/road_stretch"; // old
export const getTgSpecificOtsForCity =
  "/api/v3/org/road_stretch/:tgId/tgMetrics"; // new
